module.exports = __webpack_public_path__ + "images/img-rkS3PxO.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin-dashboard/src/assets/img/default-avatars/web_300x300.png
// module id = 2264
// module chunks = 0